import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'date-ativacao',
  templateUrl: './date-ativacao.component.html',
  styleUrls: ['./date-ativacao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DateAtivacaoComponent implements OnInit {

  now: string = new Date().toISOString().split('T')[0]; 

  private formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer
    
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this._validator();    
  }

  private _validator(){
    this.formGroup.get('dtAtivacao').clearValidators();
    this.formGroup.get('dtAtivacao').updateValueAndValidity();
  }
}
